
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_categorias,
} from '../../actions/auth.actions';

import {customgetblogs_6945b493e307249250097b00 } from '../../api/blogs.api'

import './blog.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    



const lofty_value_default_categoriame9t9_6945afffe3072492500977f7 = (param) => {
	if (param === 'estrategiasdemarketing') {
		return 'Estrategias de Marketing';
	}
	if (param === 'inteligenciaartificial') {
		return 'Inteligencia Artificial';
	}
	if (param === 'sectorfintech') {
		return 'Sector Fintech';
	}
	if (param === 'tendencias') {
		return 'Tendencias';
	}
	return param;
}




const Pblog = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_categorias,
	set_lofty_global_categorias_app,

}) => {
	const [loftystate_botontodas, set_loftystate_botontodas] = useState(true)
	const [loftystate_botonestrategias, set_loftystate_botonestrategias] = useState(true)
	const [loftystate_botonia, set_loftystate_botonia] = useState(true)
	const [loftystate_botonfintech, set_loftystate_botonfintech] = useState(true)
	const [loftystate_botontendencias, set_loftystate_botontendencias] = useState(true)

	const [loftyres_6945b493e307249250097b00_component_i726kk, setloftyres_6945b493e307249250097b00_component_i726kk] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetblogs_6945b493e307249250097b00({
					categorias: lofty_global_categorias,
				});
				setloftyres_6945b493e307249250097b00_component_i726kk(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, [lofty_global_categorias, ]);


	function function_contactanoso3otw_6943539a8e5aed52dc8c2bf0() {
		history.push("/contactus");
	}

	function function_setcategoriatodosfalse_69446a108e5aed52dc8c6b32() {
		set_lofty_global_categorias_app();
		set_loftystate_botontodas(false);
	}

	function function_setcategoriatodostrueajx9m_6944701a8e5aed52dc8c6f5b() {
		set_lofty_global_categorias_app();
		set_loftystate_botontodas(true);
		set_loftystate_botonestrategias(false);
		set_loftystate_botonia(false);
		set_loftystate_botonfintech(false);
		set_loftystate_botontendencias(false);
	}

	function function_setcategoriaestrategiastrue_694474f98e5aed52dc8c704b() {
		set_lofty_global_categorias_app("estrategiasdemarketing");
		set_loftystate_botonestrategias(true);
		set_loftystate_botontodas(false);
		set_loftystate_botonia(false);
		set_loftystate_botonfintech(false);
		set_loftystate_botontendencias(false);
	}

	function function_setcategoriaestrategiasfalse_6944753c8e5aed52dc8c7056() {
		set_lofty_global_categorias_app();
		set_loftystate_botonestrategias(false);
	}

	function function_setcategoriaiatrueqdhx9_694476a68e5aed52dc8c7140() {
		set_lofty_global_categorias_app("inteligenciaartificial");
		set_loftystate_botonia(true);
		set_loftystate_botontodas(false);
		set_loftystate_botonestrategias(false);
		set_loftystate_botonfintech(false);
		set_loftystate_botontendencias(false);
	}

	function function_setcategoriaiafalse_694476e88e5aed52dc8c714b() {
		set_lofty_global_categorias_app();
		set_loftystate_botonia(false);
	}

	function function_setcategoriafintechtrue_694478348e5aed52dc8c72c9() {
		set_lofty_global_categorias_app("sectorfintech");
		set_loftystate_botonfintech(true);
		set_loftystate_botontodas(false);
		set_loftystate_botonestrategias(false);
		set_loftystate_botonia(false);
		set_loftystate_botontendencias(false);
	}

	function function_setcategoriafintechfalse_694478628e5aed52dc8c72d4() {
		set_lofty_global_categorias_app();
		set_loftystate_botonfintech(false);
	}

	function function_setcategoriatendenciastrue_6944791f8e5aed52dc8c7372() {
		set_lofty_global_categorias_app("tendencias");
		set_loftystate_botontendencias(true);
		set_loftystate_botontodas(false);
		set_loftystate_botonestrategias(false);
		set_loftystate_botonia(false);
		set_loftystate_botonfintech(false);
	}

	function function_setcategoriatendenciasfalse_6944794e8e5aed52dc8c737d() {
		set_lofty_global_categorias_app();
		set_loftystate_botontendencias(false);
	}

	function function_redirigircontactanos_694619db8e5aed52dc8d580a() {
		history.push("https://wa.me/50487475208");
	}


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6942dbbe599f24ea479be764" >

      <div id="icuq" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/soluciones"
        type=""
      >
        <>Soluciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobregrowth"
        type=""
      >
        <>Sobre Growth</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/casosdeexito"
        type=""
      >
        <>Casos de Éxito</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="ibznw" className="">
      
        <a
          target=""
          className=""
          id="iuw1k1"
          href="/"
        >
          
      <img
        className=""
        id="ipd1e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjaas9j1.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ig5a" className="">
      
        <a
          target=""
          className=""
          id="iope"
          href="/soluciones"
        >
          
    <div id="iye9" className="">
    <>SOLUCIONES</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i848v"
          href="/sobregrowth"
        >
          
    <div id="i8s6k" className="">
    <>SOBRE GROWTH</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irmrk"
          href="/casosdeexito"
        >
          
    <div id="ib721" className="">
    <>CASOS DE ÉXITO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwshj"
          href="/blog"
        >
          
    <div id="i5dsy" className="">
    <>BLOG</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipsxb"
          href="/contactanos"
        >
          
    <div id="ii21f" className="">
    <>CONTACTO</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ibc6fg"
        className=""
        data-aos="fade-right"
        data-aos-duration="4"
      >
      
      <div id="ixav42" className="">
      
      <div id="i7dwz3" className="">
      
      <img
        className=""
        id="if1adh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="isir23"
          href="#"
        >
          <>
        </>
        </a>
        
      <img
        className=""
        id="im633h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ihoenj" className="">
      
      <div id="ir4fk5" className="">
      
      <div className="" id="ijk7un">
        
      <span className="" id="">
        
      </span>
      
    <div id="ibznk" className="">
    
      <span className="" id="inbodi">
        <>Blog</>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
      <div id="itvhki" className="">
      
      <div className="" id="ifo78j">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="i5794l">
        <>Inspírate, aprende y haz crecer tu negocio</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      <>
        </>
      </div>
      
      <div id="ij4esi" className="">
      
      <div id="izl5c9" className="">
      
      <div className="" id="ia3z3g">
        <>En nuestro blog encontrarás artículos, guías y noticias sobre las últimas tendencias en marketing digital, herramientas para emprendedores y consejos prácticos para llevar tu marca al siguiente nivel.</>
      </div>
      <>
        </>
      </div>
      
      <div id="iahfy3" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i7c4v6" className="">
      
      <div id="ibhpa6" className="">
      
      <div id="iwxfef" className="">
      
      <div className="" id="iv78ot">
        <>Tendencias de Marketing</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ij2nkt"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="itqdtz" className="">
      
      <div id="i44p27" className="">
      
      <div id="i5stol" className="">
      
      <div id="itm0r2" className="">
      
      <div id="ixw71k" className="">
      
      <div id="imht04" className="">
      
      <div className="" id="i65efo">
        <>Marketing Digital</>
      </div>
      <>
        </>
      </div>
      
      <div id="i23m9r" className="">
      
      <div className="" id="i476w8">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ii8jff" className="">
      
        <a
          target=""
          className=""
          id="ic8olv"
          href="#"
        >
          
      <img
        className=""
        id="ilwp49"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iyvdt1">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iu9ba1" className="">
      
      <div id="ip1g27" className="">
      
      <div id="iw7ie6" className="">
      
      <div className="" id="ipzecx">
        <>Marketing Digital</>
      </div>
      <>
        </>
      </div>
      
      <div id="iv6mwn" className="">
      
      <div className="" id="iy5kdv">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="i4etpc" className="">
      
        <a
          target=""
          className=""
          id="iboau3"
          href="#"
        >
          
      <img
        className=""
        id="i0orwj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iqtgyj">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ilpiwl" className="">
      
      <div id="iqbbu7" className="">
      
      <div id="ioeiaq" className="">
      
      <div id="itvybr" className="">
      
      <div className="" id="ish83g">
        <>Marketing Digital</>
      </div>
      <>
        </>
      </div>
      
      <div id="iwyysp" className="">
      
      <div className="" id="id3wy7">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ibp7w6" className="">
      
        <a
          target=""
          className=""
          id="i6076d"
          href="#"
        >
          
      <img
        className=""
        id="iadb4f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="imsxju">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ielcct" className="">
      
      <div id="iginp8" className="">
      
      <div id="ikobq9" className="">
      
      <div className="" id="iv6afy">
        <>Marketing Digital</>
      </div>
      <>
        </>
      </div>
      
      <div id="i89twb" className="">
      
      <div className="" id="iiq20f">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="iywklu" className="">
      
        <a
          target=""
          className=""
          id="ig6zdw"
          href="#"
        >
          
      <img
        className=""
        id="itfvxu"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iplkha">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iwd3nj" className="">
      
      <div id="il2sbp" className="">
      
      <div id="iehsea" className="">
      
      <div id="is9r5t" className="">
      
      <div className="" id="i1glg8">
        <>Marketing Digital</>
      </div>
      <>
        </>
      </div>
      
      <div id="ilrnff" className="">
      
      <div className="" id="izrizn">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ir7ij9" className="">
      
        <a
          target=""
          className=""
          id="ie5p4h"
          href="#"
        >
          
      <img
        className=""
        id="imq7jy"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="i501el">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iwqhhh" className="">
      
      <div id="i2komk" className="">
      
      <div id="ivvqfy" className="">
      
      <div className="" id="imfkq4">
        <>Marketing Digital</>
      </div>
      <>
        </>
      </div>
      
      <div id="i1vbfz" className="">
      
      <div className="" id="iexp18">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="irz9fi" className="">
      
        <a
          target=""
          className=""
          id="i4xf53"
          href="#"
        >
          
      <img
        className=""
        id="inett3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="itmzif">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ikfp5n"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="itsbs4" className="">
      
        <div id="iyrn45" className="">
        
      <div id="iorhj7" className="">
      
      <div id="i4vkfu" className="">
      
      <div id="idjp1k" className="">
      
      <div id="ilqo62" className="">
      
        <div className="" id="ibjohn">
          
      <div id="ixxepi" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        <>
        </>
      </div>
      
      <div id="iivx5g" className="">
      
        <div className="" id="igfn5b">
          
      <div id="ibd32c" className="">
      <>
         &#123;&#123; descripcioncortawz1jgj &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="itleug" className="">
      
        <a
          target=""
          className=""
          id="igzwpl"
          href="#"
        >
          
      <img
        className=""
        id="i7bsaf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iou1iw">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        <>
        </>
      </div>
      
      </div>
      
      <div
        id="i00vk1"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="iezy17" className="">
      
        <div id="ihhpj3" className="">
        
      <div id="i2vx3a" className="">
      
      <div id="iy2a5j" className="">
      
      <div id="ias72v" className="">
      
      <div id="i66hif" className="">
      
        <div className="" id="iyvbrh">
          
      <div id="iv4n1l" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        <>
        </>
      </div>
      
      <div id="i1rbzn" className="">
      
        <div className="" id="ivzj6w">
          
      <div id="iwkn4j" className="">
      <>
         &#123;&#123; descripcioncortawz1jgj &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="iwv09b" className="">
      
        <a
          target=""
          className=""
          id="i7jump"
          href={`/article/null`}
        >
          
      <img
        className=""
        id="i4jha2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="i7d3tt">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        <>
        </>
      </div>
      
      </div>
      
      <div id="ir0clq" className="">
      
      <div id="i199wc" className="">
      
      <button
        type=""
        name=""
        id="inl38z"
        className=""
        
      >
      
      <div id="i7mwbu" className="">
      <>Todas</>
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="ipeikt"
        className=""
        
      >
      
      <div id="ikv06d" className="">
      <>Estrategias de marketing</>
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="itwbb8"
        className=""
        
      >
      
      <div id="i2l1q2" className="">
      <>Inteligencia Artificial</>
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="iz61vg"
        className=""
        
      >
      
      <div id="i5ez4u" className="">
      <>Sector Fintech</>
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="i0cxkr"
        className=""
        
      >
      
      <div id="ibygxu" className="">
      <>Tendencias</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ib86kn" className="">
      
      <div id="iqjjhh" className="">
      
              <div id="ivh4yk" className="">
                {
                  loftystate_botontodas && (
                    <div style={{display: 'block'}} className="" id="ib4yel">
                      
      <button
        type=""
        name=""
        id="idolqk"
        className=""
        onClick={async () => {
		function_setcategoriatodosfalse_69446a108e5aed52dc8c6b32();
}}

      >
      
      <div id="izc01o" className="">
      <>Todas</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
                {
                  !loftystate_botontodas && (
                    <div style={{display: 'block'}} className="" id="iavw43">
                      
      <button
        type=""
        name=""
        id="iqp4ak"
        className=""
        onClick={async () => {
		function_setcategoriatodostrueajx9m_6944701a8e5aed52dc8c6f5b();
}}

      >
      
      <div id="il0m5i" className="">
      <>Todas</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
              </div>
            
              <div id="igqv1k" className="">
                {
                  loftystate_botonestrategias && (
                    <div style={{display: 'block'}} className="" id="iuhgan">
                      
      <button
        type=""
        name=""
        id="i5n8ng"
        className=""
        onClick={async () => {
		function_setcategoriaestrategiasfalse_6944753c8e5aed52dc8c7056();
}}

      >
      
      <div id="igdewg" className="">
      <>Estrategias de marketing</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
                {
                  !loftystate_botonestrategias && (
                    <div style={{display: 'block'}} className="" id="iba2jd">
                      
      <button
        type=""
        name=""
        id="i763ly"
        className=""
        onClick={async () => {
		function_setcategoriaestrategiastrue_694474f98e5aed52dc8c704b();
}}

      >
      
      <div id="iquak6" className="">
      <>Estrategias de marketing</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
              </div>
            
              <div id="iqaiyx" className="">
                {
                  loftystate_botonia && (
                    <div style={{display: 'block'}} className="" id="iux451">
                      
      <button
        type=""
        name=""
        id="ivaxng"
        className=""
        onClick={async () => {
		function_setcategoriaiafalse_694476e88e5aed52dc8c714b();
}}

      >
      
      <div id="i7w07b" className="">
      <>Inteligencia Artificial</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
                {
                  !loftystate_botonia && (
                    <div style={{display: 'block'}} className="" id="ikwa1a">
                      
      <button
        type=""
        name=""
        id="iuui5q"
        className=""
        onClick={async () => {
		function_setcategoriaiatrueqdhx9_694476a68e5aed52dc8c7140();
}}

      >
      
      <div id="ie0927" className="">
      <>Inteligencia Artificial</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
              </div>
            
              <div id="i3useb" className="">
                {
                  loftystate_botonfintech && (
                    <div style={{display: 'block'}} className="" id="izr7xm">
                      
      <button
        type=""
        name=""
        id="iy5mo8"
        className=""
        onClick={async () => {
		function_setcategoriafintechfalse_694478628e5aed52dc8c72d4();
}}

      >
      
      <div id="iz7pmi" className="">
      <>Sector Fintech</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
                {
                  !loftystate_botonfintech && (
                    <div style={{display: 'block'}} className="" id="iv7flm">
                      
      <button
        type=""
        name=""
        id="icswwh"
        className=""
        onClick={async () => {
		function_setcategoriafintechtrue_694478348e5aed52dc8c72c9();
}}

      >
      
      <div id="i0l3ct" className="">
      <>Sector Fintech</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
              </div>
            
              <div id="is5fxk" className="">
                {
                  loftystate_botontendencias && (
                    <div style={{display: 'block'}} className="" id="il69zg">
                      
      <button
        type=""
        name=""
        id="iw83oz"
        className=""
        onClick={async () => {
		function_setcategoriatendenciasfalse_6944794e8e5aed52dc8c737d();
}}

      >
      
      <div id="itqnrf" className="">
      <>Tendencias</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
                {
                  !loftystate_botontendencias && (
                    <div style={{display: 'block'}} className="" id="irz4ph">
                      
      <button
        type=""
        name=""
        id="igr15g"
        className=""
        onClick={async () => {
		function_setcategoriatendenciastrue_6944791f8e5aed52dc8c7372();
}}

      >
      
      <div id="i9vygi" className="">
      <>Tendencias</>
      </div>
      
      </button>
      
                    </div>
                  )
                }
              </div>
            <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ight9p"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="iqinkg" className="">
      
        <div id="i6wte9" className="">
        
      <div id="i5ugqg" className="">
      
      <div id="iw31k6" className="">
      
      <div id="ia46zd" className="">
      
      <div id="i76zbn" className="">
      
        <div className="" id="i2zthy">
          
      <div id="ijzeal" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        <>
        </>
      </div>
      
      <div id="ixmn8e" className="">
      
        <div className="" id="ixvpcc">
          
      <div id="icjjim" className="">
      <>
         &#123;&#123; descripcioncortawz1jgj &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="imzn91" className="">
      
        <a
          target=""
          className=""
          id="imgf7t"
          href={`/article/null`}
        >
          
      <span className="material-icons " id="ig7nou">
        <>expand_more</>
      </span>
      
      <span className="" id="iy0wta">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <span className="material-icons " id="ijltwn">
        
      </span>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        <>
        </>
      </div>
      
      </div>
      
      <div
        id="i13vlx"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="irxlmk" className="">
      
        <div id="i726kk" className="">
        
            {
              loftyres_6945b493e307249250097b00_component_i726kk?.map((loftyitem_6945b493e307249250097b00_component_i726kk) => (
                <div key={loftyitem_6945b493e307249250097b00_component_i726kk._id} className="" id="iyezjg">
                  
      <div id="ibp3cz" className="">
      
      <div id="igdl9f" className="">
      
        <img
          className=""
          id="itzock"
          alt=""
          src={loftyitem_6945b493e307249250097b00_component_i726kk?.loftyUrl}
        />
        <>
        </>
      </div>
      
      <div id="iymzo9" className="">
      
      <div id="ifo1pi" className="">
      
        <div className="" id="iw2dq2">
          
          <div className="" id="">
            {loftyitem_6945b493e307249250097b00_component_i726kk?.titulob4w5}
          </div>
          
        </div>
        <>
        </>
      </div>
      
      <div id="ik2xtn" className="">
      
        <div className="" id="imxfku">
          
          <div className="" id="">
            {loftyitem_6945b493e307249250097b00_component_i726kk?.descripcioncortag1oay}
          </div>
          
        </div>
        
      <div id="ihcfyh" className="">
      
        <a
          target=""
          className=""
          id="i9jpk7"
          href={`/articulo/${loftyitem_6945b493e307249250097b00_component_i726kk._id}`}
        >
          
      <span className="material-icons " id="isnowh">
        <>expand_more</>
      </span>
      
      <span className="" id="igqrvd">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <span className="material-icons " id="icvyqp">
        
      </span>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        <>
        </>
      </div>
      
      </div>
      
      <div id="i1e57n" className="">
      <>
        </>
      </div>
      
      <div
        id="ijx51z"
        className=""
        data-aos="fade-right"
        data-aos-duration="undefined"
      >
      
      <div id="ii98wj" className="">
      
      <div id="i4o484" className="">
      
      <div id="ie9gps" className="">
      
      <img
        className=""
        id="ihpb4z"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgsmyycv.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="inffmy" className="">
      
      <div className="" id="igpidq">
        <>Tips para Emprendedores</>
      </div>
      <>
        </>
      </div>
      
      <div id="ieuq1v" className="">
      
      <div id="itjo0j" className="">
      
      <div id="ijvkg9" className="">
      
      <div id="idjc5m" className="">
      
      <div id="ifbzr5" className="">
      
      <div className="" id="iqaxbf">
        <>“7 errores comunes que frenan el crecimiento de un emprendimiento”</>
      <br className="" id="" />
      
      </div>
      
      <div id="ird9qd" className="">
      
        <a
          target=""
          className=""
          id="i2tkoh"
          href="#"
        >
          
      <img
        className=""
        id="iup977"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtk6pp6.png"
        alt="undefined"
      />
      
      <span className="" id="ih9g0o">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iwsq0v" className="">
      
      <div id="i0lv7b" className="">
      
      <div id="i57q8g" className="">
      
      <div id="idbb7q" className="">
      
      <div className="" id="i2yk8b">
        <>“Cómo crear una marca fuerte sin gastar una fortuna”</>
      <br className="" id="" />
      
      </div>
      
      <div id="iqyur7" className="">
      
        <a
          target=""
          className=""
          id="il2bob"
          href="#"
        >
          
      <img
        className=""
        id="i0kkqo"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtk6pp6.png"
        alt="undefined"
      />
      
      <span className="" id="iss0jg">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ixpkyk" className="">
      
      <div id="i26c3l" className="">
      
      <div id="i9cfiw" className="">
      
      <div id="i4de4y" className="">
      
      <div className="" id="ix0yec">
        <>“Productividad para emprendedores: herramientas que sí funcionan”</>
      <br className="" id="" />
      
      </div>
      
      <div id="ilc25k" className="">
      
        <a
          target=""
          className=""
          id="i3poa5"
          href="#"
        >
          
      <img
        className=""
        id="ijs7hz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtk6pp6.png"
        alt="undefined"
      />
      
      <span className="" id="ighhag">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="iv8scf"
        className=""
        data-aos="fade-right"
        data-aos-duration="undefined"
      >
      
      <div id="ipk8rq" className="">
      
      <div id="izdb7j" className="">
      
      <div id="ikqmwh" className="">
      
      <img
        className=""
        id="iaxxuj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgsmyycv.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ikh2r8" className="">
      
      <div className="" id="irdnti">
        <>Tips para Emprendedores</>
      </div>
      <>
        </>
      </div>
      
      <div id="i7gyhg" className="">
      
        <div id="ikwetf" className="">
        
      <div id="ig6j7t" className="">
      
      <div id="iy4ref" className="">
      
      <div id="iysrvh" className="">
      
        <div className="" id="i6lvz5">
          
      <div id="iuwnqx" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="iikwng" className="">
      
        <a
          target=""
          className=""
          id="iefmem"
          href={`/article/null`}
        >
          
      <img
        className=""
        id="ig0i2v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtk6pp6.png"
        alt="undefined"
      />
      
      <span className="" id="im61pk">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i17jxt" className="">
      
      <div id="igc5yk" className="">
      
      <div className="" id="ielw3g">
        <>Noticias & Actualidad</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ietlyk"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="ivbyq4" className="">
      
      <div id="iz1onw" className="">
      
      <div id="ish8r2" className="">
      
      <div id="iipjj4" className="">
      
      <div id="irb963" className="">
      
      <div id="injw8w" className="">
      
      <div className="" id="imqzii">
        <>Cambios en el algoritmo de Instagram: lo que debes saber</>
      <br className="" id="" />
      
      </div>
      
      <div id="ikts1l" className="">
      
        <a
          target=""
          className=""
          id="i54ibn"
          href="#"
        >
          
      <img
        className=""
        id="ifxj6m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="izr9ym">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i16c6k" className="">
      
      <div id="ilcy71" className="">
      
      <div id="iqjeud" className="">
      
      <div className="" id="ifvott">
        <>Cambios en el algoritmo de Instagram: lo que debes saber</>
      <br className="" id="" />
      
      </div>
      
      <div id="igj8fh" className="">
      
        <a
          target=""
          className=""
          id="ihwvxl"
          href="#"
        >
          
      <img
        className=""
        id="ibzvtn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="is9zd2">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="idviyz" className="">
      
      <div id="ipag8v" className="">
      
      <div id="ilg6o9" className="">
      
      <div id="iqvjyj" className="">
      
      <div className="" id="iapswk">
        <>La evolución del e-commerce en Latinoamérica</>
      <br className="" id="" />
      
      </div>
      
      <div id="il3mau" className="">
      
        <a
          target=""
          className=""
          id="ija4xj"
          href="#"
        >
          
      <img
        className=""
        id="ifkeuv"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="ibjo3i">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iatrmp" className="">
      
      <div id="i91mbb" className="">
      
      <div id="ijg8zv" className="">
      
      <div className="" id="i0dfwj">
        <>La evolución del e-commerce en Latinoamérica</>
      <br className="" id="" />
      
      </div>
      
      <div id="iffmgi" className="">
      
        <a
          target=""
          className=""
          id="ia8jrx"
          href="#"
        >
          
      <img
        className=""
        id="i3j8b5"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="if5y14">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ivq54j" className="">
      
      <div id="iovd3i" className="">
      
      <div id="iz24ny" className="">
      
      <div id="ibf887" className="">
      
      <div className="" id="i9tff3">
        <>¿Qué significa el nuevo reglamento de datos para las marcas?</>
      <br className="" id="" />
      
      </div>
      
      <div id="i4zzjh" className="">
      
        <a
          target=""
          className=""
          id="isg6if"
          href="#"
        >
          
      <img
        className=""
        id="i9ha9h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="itcptj">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i4aoau" className="">
      
      <div id="ils6q9" className="">
      
      <div id="i8cgup" className="">
      
      <div className="" id="inrw29">
        <>¿Qué significa el nuevo reglamento de datos para las marcas?</>
      <br className="" id="" />
      
      </div>
      
      <div id="iyspk4" className="">
      
        <a
          target=""
          className=""
          id="i0k05b"
          href="#"
        >
          
      <img
        className=""
        id="iwhjt7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="i1vy1k">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ivnwhb"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="ifoy2o" className="">
      
        <div id="ipxn0i" className="">
        
      <div id="i4m93v" className="">
      
      <div id="ind1oj" className="">
      
      <div id="it2b2h" className="">
      
      <div id="iw67sj" className="">
      
        <div className="" id="ijr8b4">
          
      <div id="iz1czj" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="ihvwlb" className="">
      
        <a
          target=""
          className=""
          id="ic2q56"
          href="#"
        >
          
      <img
        className=""
        id="i9zsz1"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="imw56b">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        <>
        </>
      </div>
      
      </div>
      
      <div
        id="iijdoa"
        className=""
        data-aos="fade-up"
        data-aos-duration="3"
      >
      
      <div id="ih914h" className="">
      
        <div id="ija69k" className="">
        
      <div id="ibtf8d" className="">
      
      <div id="i76g05" className="">
      
      <div id="iwgfec" className="">
      
        <div className="" id="i9z4l1">
          
      <div id="ikhzaa" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="i3hy8j" className="">
      
      <div id="icvd3m" className="">
      
        <a
          target=""
          className=""
          id="ix0ztj"
          href={`/article/null`}
        >
          
      <img
        className=""
        id="ioof9l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="imprfg">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        <>
        </>
      </div>
      
      </div>
      
      <div id="ioljq7" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="isqkaw" className="">
      
      <div id="inwpbh" className="">
      
      <div id="iblzwv" className="">
      
      <img
        className=""
        id="i2yoxn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpsbgsp.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="imbbrp" className="">
      
      <div className="" id="i6egud">
        <>¿Listo para crecer con claridad?</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iynesv" className="">
      
      <div id="ibuain" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button2 "
        onClick={async () => {
		function_redirigircontactanos_694619db8e5aed52dc8d580a();
}}

      >
      
      <div id="i4o7pt" className="">
      
      <span className="" id="i1ckiy">
        <>Escríbenos por WhatsApp</>
      </span>
      
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="iby52g"
        className=""
        
      >
      
      </button>
      <>
        </>
      </div>
      
      <div id="ilk8u9" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		function_redirigircontactanos_694619db8e5aed52dc8d580a();
}}

      >
      
      <div id="ih6ehn" className="">
      <>Agenda una cita</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i8i7v6" className="">
      
      <div id="id0agl" className="">
      
      <img
        className=""
        id="ilddrm"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja92k5o.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ihicma" className="">
      
      <div id="ixwklp" className="">
      
      <div className="" id="ir09ij">
        <>1234 Pais, Ciudad, Depto,</>
      <br className="" id="" />
      <> CA</>
      </div>
      <>
        </>
      </div>
      
      <div id="i6uq4v" className="">
      
      <div className="" id="ibujo5">
        <>+504 123456789</>
      </div>
      <>
        </>
      </div>
      
      <div id="i546wk" className="">
      
      <div className="" id="im11om">
        <>info@marketingdigital.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ibbe75" className="">
      
        <a
          target=""
          className=""
          id="ii6hgt"
          href="/"
        >
          
      <div className="" id="ixvcl3">
        <>Inicio</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="it4gg5"
          href="/soluciones"
        >
          
      <div className="" id="i7gpgj">
        <>Soluciones</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i27pt3"
          href="/sobregrowth"
        >
          
      <div className="" id="i7xzul">
        <>Sobre Growth</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="ip26pf"
          href="/casosdeexito"
        >
          
      <div className="" id="ilfzlg">
        <>Casos de Éxito</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="isobhn"
          href="/blog"
        >
          
      <div className="" id="imnfxi">
        <>Blog</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i1uw07"
          href="/contactanos"
        >
          
      <div className="" id="ii15va">
        <>Contacto</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="igzgl4" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="indubl" className="">
      
      <div id="i21uc2" className="">
      <>
        </>
      </div>
      
      <div id="inwhc2" className="">
      
      <div id="ig0f9m" className="">
      
      <img
        className=""
        id="i8uhy6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpus7um.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ippo57"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjam6dd7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iwkvyf" className="">
      
      <div className="" id="ig7fxf">
        <>© 2025 Growth Holístico. Todos los derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
        <a
          target=""
          className=""
          id="iy927j"
          href="https://wa.me/50487475208"
        >
          
      <img
        className=""
        id="i6i43m"
        src="https://assetsprojects.s3.amazonaws.com/405gznimll0fka3.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_categorias_app: (value) => dispatch(set_lofty_global_categorias(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pblog);
  